/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Transcript_EmptyInputs */



/**
* | output |
* | --- |
* | "No transcript available" |
*
* @param {Meeting_Transcript_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_transcript_empty = /** @type {((inputs?: Meeting_Transcript_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Transcript_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Geen transcript beschikbaar")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune transcription disponible")
	return /** @type {LocalizedString} */ ("No transcript available")
});